module.exports = __webpack_public_path__ + "img/back_buttons_quantity.c776235b.png";